import { Field, FieldRenderProps } from '@progress/kendo-react-form'
import { min } from 'lodash'
import React, { FunctionComponent } from 'react'
import { Api } from '../../redux/api/BaseApi'
import FormField from './FormField'
import {
  Label
} from "@progress/kendo-react-labels";
import Fields from './Fields'
import { skip } from '@progress/kendo-data-query/dist/npm/transducers'
import { useReduxSelector } from '../../redux/hooks'


const CustomFormControl: FunctionComponent<FieldRenderProps> = formRenderProps => {
  const {
    id,
    disabled,
    valid,
    optional,
    validationMessage,
    form,
    fields,
    ...others
  } = formRenderProps;

  //const { data: form } = Api.useGetFormQuery(formId, { skip: fields });

  if (!form)
    return <></>

  return (
    <>
      {!form?.Show_Tooltip && form?.Description && <div className='m-0 p-2 text-muted'>{form?.Description}</div>}
      <Fields valid={valid} validationMessage={validationMessage} form={form} fields={fields} {...others} />
      {/* Required for css rendering */}
      <div className="basis-full md:basis-1/2 lg:basis-1/3 xl:basis-1/4"></div>
      {/* <JsonTreeViewer data={fields} title="Custom Form" /> */}
    </>
  )
}


export default CustomFormControl;